class MatchMeController {
  constructor($rootScope, $window, $location, AnchorSmoothScroll) {
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.$location = $location;
    this.AnchorSmoothScroll = AnchorSmoothScroll;
    this.showMatchMe = false;
  }
  toggleMatchMe() {
    if (this.$window.innerWidth >= 1000) {
      this.showMatchMe = true;
      this.AnchorSmoothScroll.scrollTo('matchMe');
    } else {
      this.AnchorSmoothScroll.scrollTo('customize-button');
      this.$rootScope.$emit('OPEN_CUSTOMIZE_BUTTON');
    }
  }
}

MatchMeController.$inject = ['$rootScope', '$window', '$location', 'AnchorSmoothScroll'];

export default MatchMeController;



// WEBPACK FOOTER //
// ./src/components/matchMe/matchMe.controller.js